import { useState } from 'react'
import Button from './ui/Button'
import { useToast } from './ui/Toast'
import { createShare } from '../lib/api.share'
import textsShare from '../texts.share'

interface ShareButtonProps {
  gameId: number
}

async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    try {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      return true
    } catch {
      return false
    }
  }
}

/** Ghost-knap der opretter (eller genbruger) et delt link og deler/kopierer det. */
function ShareButton({ gameId }: ShareButtonProps) {
  const { showToast } = useToast()
  const [sharing, setSharing] = useState(false)

  const handleShare = async () => {
    setSharing(true)
    try {
      const { token } = await createShare(gameId)
      const url = `${window.location.origin}/r/${token}`
      if (navigator.share) {
        try {
          await navigator.share({ title: textsShare.share.button, url })
        } catch {
          // Brugeren annullerede share-sheetet
        }
      } else {
        const copied = await copyToClipboard(url)
        if (copied) showToast(textsShare.share.linkCopied)
      }
    } catch {
      showToast(textsShare.share.couldNotShare)
    } finally {
      setSharing(false)
    }
  }

  return (
    <Button variant="ghost" size="sm" onClick={handleShare} disabled={sharing}>
      {textsShare.share.button}
    </Button>
  )
}

export default ShareButton
